import React, { useEffect, useState, useCallback } from "react";
import Video from "./Video";


export default function Channel() {
  const num = Math.floor(100000 + Math.random() * 900000);
    const serverLink = "https://api.ndsql.top/tv/playlist.m3u?id="+num;

    const [channels, setChannels] = useState([]);
    const [selectChannel, setSelectChannel] = useState("");
    const [hashCode, setHashCode] = useState(window.location.hash);

    // M3U Parser
    const parseM3U = (text) => {
        const list = [];
        const blocks = text.split("#EXTINF:");
        blocks.shift();

        blocks.forEach((block) => {
            const lines = block
                .split(/\r?\n/)
                .map((line) => line.trim())
                .filter(Boolean);

            if (!lines.length) return;

            const info = lines[0];

            const url = lines.find(
                (line) =>
                    !line.startsWith("#") &&
                    /^https?:\/\//i.test(line)
            );

            if (!url) return;

            const name = info.split(",").pop().trim();

            const tvgid =
                info.match(/tvg-id="([^"]+)"/)?.[1] || "";

            const username = (
                tvgid || name
            )
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "_");

            const icon =
                info.match(/tvg-logo="([^"]+)"/)?.[1] || "";

            const group =
                info.match(/group-title="([^"]+)"/)?.[1] || "";

            const userAgent =
                info.match(/user-agent="([^"]+)"/)?.[1] || "";

            list.push({
                username,
                tvgid,
                name,
                icon,
                group,
                userAgent,
                live: url,
            });
        });

        return list;
    };

    // Load Playlist
    useEffect(() => {
        fetch(serverLink)
            .then((res) => res.text())
            .then((text) => {
                const data = parseM3U(text);

                console.log("Channels:", data.length);

                setChannels(data);
            })
            .catch((err) => console.error(err));
    }, []);

    // Hash Load
    const loadChannel = useCallback(() => {
        if (!channels.length) return;

        const hash = window.location.hash.replace("#", "");

        let current = channels.find(
            (item) => item.username === hash
        );

        if (!current) {
            current = channels[0];
            window.location.hash = current.username;
        }

        setSelectChannel(current.live);
        setHashCode("#" + current.username);

    }, [channels]);

    useEffect(() => {
        loadChannel();
    }, [loadChannel]);

    useEffect(() => {
        window.addEventListener("hashchange", loadChannel);

        return () => {
            window.removeEventListener(
                "hashchange",
                loadChannel
            );
        };
    }, [loadChannel]);

    // Channel Change
    const mirrorVinChannel = (item) => {
        setSelectChannel(item.live);
        setHashCode("#" + item.username);
        window.location.hash = item.username;
    };

    return (
        <>
            <Video data={selectChannel} />

            <div className="w100">

                <h2
                    style={{
                        textAlign: "center",
                        margin: "20px 0",
                    }}
                >
                    Channel ({channels.length})
                </h2>

                <hr />

                <div className="flex center medel wrap">

                    {channels.map((item, index) => (
                        <div
                            key={index}
                            className={`channel flex center medel ${hashCode === "#" + item.username
                                    ? "active"
                                    : ""
                                }`}
                            onClick={() =>
                                mirrorVinChannel(item)
                            }
                        >
                            <img
                                className="channel-img"
                                src={item.icon || undefined}
                                alt={item.name}
                            />

                            <div
                                style={{
                                    marginTop: 5,
                                    fontSize: 12,
                                    textAlign: "center",
                                }}
                            >
                                {item.name}
                            </div>

                        </div>
                    ))}

                </div>

            </div>
        </>
    );
}